import { Box } from "@chakra-ui/react";
import {
  TabMenuOptions,
  TabsClientes,
} from "core/features/clientes-tenant/data/TabsClientes";
import { showError } from "infra/helpers/alerta";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";

import MenuDetalhes from "components/Menu/MenuDetalhes";
import TenantHeader from "./components/TenantHeader";
import ClientesTabs from "./components/ClientesTabs";
import history from "infra/helpers/history";
import { useBreadcrumb } from "features/breadcrumbs";
import { useLoading } from "components/GlobalLoading";
import { useCliente } from "core/features/clientes-tenant/hooks";
import ModalTipo from "./components/ModalTipo";
import { TipoTenantEnum } from "core/resources/enums/tenant";
import Container from "components/Container";

function CriarEditarClientes() {
  const { id } = useParams() as { id?: string };

  const [tipoTenantId, setTipoTenantId] = useState<TipoTenantEnum>();

  const createDisabledOptions = TabMenuOptions.filter(
    (option) => option.route !== TabMenuOptions[0].route
  ).map((option) => option.route); // .filter(route => route !== );

  useBreadcrumb([
    { name: "Clientes", url: "/clientes" },
    { name: `${id ? "Editar" : "Criar"} Cliente`, url: "/clientes/criar" },
  ]);

  const opcaoParam =
    new URLSearchParams(useLocation().search).get("opcao") ||
    TabsClientes.Dados;

  const [selectedMenuOption, setSelectedMenuOption] = useState(opcaoParam);

  const { data: tenant, isLoading, isError } = useCliente(id);

  useLoading(isLoading);

  const enableEditOptions = !!id;

  useEffect(() => {
    if (isError) {
      showError("Houve um problema ao realizar esta operação").then(() => {
        history.push("/clientes");
      });
    }
  }, [isError]);

  if (isError) {
    return null;
  }

  return (
    <Container>
      {!isLoading && !tenant?.id ? (
        <ModalTipo
          onSave={(tipo) => {
            setTipoTenantId(tipo);
          }}
        />
      ) : null}

      <TenantHeader tenant={{ tipoTenantId, ...(tenant ?? {}) } as any} />
      <Box
        mt={8}
        gridGap={8}
        display="flex"
        flexDir={["column", "column", "row"]}
      >
        <Box mb={4}>
          <MenuDetalhes
            options={TabMenuOptions}
            disabledOptions={enableEditOptions ? [] : createDisabledOptions}
            selectedOption={selectedMenuOption ?? TabsClientes.Dados}
            onChangeOption={(tab) => {
              setSelectedMenuOption(tab);
              if (id) {
                history.push(`/clientes/${id}?opcao=${tab}`);
              } else {
                history.push(`/clientes/criar?opcao=${tab}`);
              }
            }}
          />
        </Box>
        <Box flex={1}>
          <ClientesTabs
            tenant={{ tipoTenantId, ...(tenant ?? {}) } as any}
            id={id}
            tabActive={
              (selectedMenuOption as TabsClientes) ?? TabsClientes.Dados
            }
            onSubmitSuccess={() => {
              if (!id) {
                return history.push(`/clientes`);
              }
              window.location.reload();
            }}
          />
        </Box>
      </Box>
    </Container>
  );
}

export default CriarEditarClientes;
